/*
  Resource Manifest Redux-Sagas Setup
*/

import { takeLatest, select, call, put } from 'redux-saga/effects';
import { replace } from 'connected-react-router';
import { delay } from 'redux-saga';

import Api from '../api';

import {
  FETCH_SLOTS_REQUEST,
  FETCH_SLOTS_SUCCESS,
  FETCH_SLOTS_FAILURE,
  UPDATE_SLOT_FILTER,
  CHANGE_PAGE,
  FETCH_SLOT_REQUEST,
  FETCH_SLOT_SUCCESS,
  FETCH_SLOT_FAILURE,
  FETCH_MORE_SLOTS_REQUEST,
  FETCH_MORE_SLOTS_FAILURE,
  FETCH_MORE_SLOTS_SUCCESS,
  CANCEL_SLOT_REQUEST,
  CANCEL_SLOT_SUCCESS,
  CANCEL_SLOT_FAILURE,
  SHOW_NOTIFICATION,
} from '../actions/slotsActionTypes';

const getSlotFilter = (state) => state.slots.slotFilter;
const getPage = (state) => state.slots.page;

// Worker sagas =====
// Do the work when watcher saga sees the action
function* fetchSlots(action) {
  try {
    const slotFilter = yield select(getSlotFilter);
    const page = yield select(getPage);

    const params = { slotFilter, page };
    const response = yield call(Api.fetchSlots, params);
    const slots = response.data.slots.data;
    const { totalPages } = response.data;

    yield put({ type: FETCH_SLOTS_SUCCESS, slots, totalPages });
  } catch (error) {
    yield put({ type: FETCH_SLOTS_FAILURE, error });
  }
}

function* fetchMoreSlots(action) {
  try {
    const slotFilter = yield select(getSlotFilter);
    let page = yield select(getPage);
    page += 1;

    const params = { slotFilter, page };
    const response = yield call(Api.fetchSlots, params);
    const slots = response.data.slots.data;
    const { totalPages } = response.data;

    yield put({ type: FETCH_MORE_SLOTS_SUCCESS, slots, totalPages, page });
  } catch (error) {
    yield put({ type: FETCH_MORE_SLOTS_FAILURE, error });
  }
}

function* fetchSlot(action) {
  try {
    const { slotId } = action;
    const params = { slotId };
    const response = yield call(Api.fetchSlot, params);
    const slot = response.data.data;
    yield put({ type: FETCH_SLOT_SUCCESS, slot });
  } catch (error) {
    yield put({ type: FETCH_SLOT_FAILURE, error });
  }
}

function* cancelSlot(action) {
  try {
    const { slotId, guestNote } = action;
    const params = { slotId, guestNote };
    const response = yield call(Api.cancelSlot, params);
    const slot = response.data.data;
    yield put({ type: CANCEL_SLOT_SUCCESS, slot });
    yield put({ type: FETCH_SLOTS_REQUEST });
    yield put(replace('/scheduled'));

    yield put({
      type: SHOW_NOTIFICATION,
      notice: 'Your class has been successfully cancelled.',
      noticeType: 'notice',
    });
    // Wait for 3 secs before hiding notification
    yield delay(3000);
    yield put({ type: SHOW_NOTIFICATION, notice: null });
  } catch (error) {
    yield put({ type: CANCEL_SLOT_FAILURE, error });
    yield put(replace('/scheduled'));

    yield put({
      type: SHOW_NOTIFICATION,
      notice:
        'An error occurred while cancelling your class. Please try again.',
      noticeType: 'error',
    });
    // Wait for 3 secs before hiding notification
    yield delay(3000);
    yield put({ type: SHOW_NOTIFICATION, notice: null });
  }
}

function* updateSlotFilter(action) {
  try {
    // Refresh slot list when toggling between upcoming/past
    yield put({ type: FETCH_SLOTS_REQUEST });
  } catch (error) {
    console.log(error);
  }
}

export const slotSagas = [
  takeLatest(FETCH_SLOTS_REQUEST, fetchSlots),
  takeLatest(CHANGE_PAGE, fetchSlots),
  takeLatest(FETCH_MORE_SLOTS_REQUEST, fetchMoreSlots),
  takeLatest(FETCH_SLOT_REQUEST, fetchSlot),
  takeLatest(CANCEL_SLOT_REQUEST, cancelSlot),
  takeLatest(UPDATE_SLOT_FILTER, updateSlotFilter),
];
